// watchlistSlice.js
import { createSlice } from '@reduxjs/toolkit';

const watchlistSlice = createSlice({
    name: 'watchlist',
    initialState: {
        list: JSON.parse(localStorage.getItem('watchlist')) || [],
        isCreated: false,
        activeTitle: null,
        activeTitleId: null,
    },
    reducers: {
        setWatchlist: (state, action) => {
            state.list = action.payload;
            localStorage.setItem('watchlist', JSON.stringify(action.payload));
        },
        addItemToWatchlist: (state, action) => {
            state.list.push(action.payload);
            updateWatchlistStorage(state.list);
        },
        removeItemFromWatchlist: (state, action) => {
            state.list = state.list.filter(item => item.watchlistId !== action.payload);
            updateWatchlistStorage(state.list);
            state.recentAction = 'remove';
        },
        setCreatedStatus: (state, action) => {
            state.isCreated = action.payload;
        },
        setActiveTitle: (state, action) => {
            state.activeTitle = action.payload;
        },
        setActiveTitleId: (state, action) => {
            state.activeTitleId = action.payload;
        },
        setActiveListBarItem: (state, action) => {
            state.activeListBarItem = action.payload;

        },
    },
});

const updateWatchlistStorage = (list) => {
    localStorage.removeItem('watchlist');
    localStorage.setItem('watchlist', JSON.stringify(list));
}

export const {
    setWatchlist,
    addItemToWatchlist,
    removeItemFromWatchlist,
    setCreatedStatus,
    setActiveTitle,
    setActiveTitleId,
    setActiveListBarItem,
} = watchlistSlice.actions;

export default watchlistSlice.reducer;